import React from 'react';
import { DI } from 'modules';
import Component from 'components/component';
// import DEPRECATED_moment from 'moment-timezone';
import { plural } from 'helpers/strings';
import { DateTime } from 'luxon';

class StatusBase extends Component {
  state = {
    label: 'live',
    hover: false,
    time: '',
    ico: null
  };

  componentDidMount() {
    this.setLiveStatus();
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setLiveStatus();
    }
  }

  setLiveStatus = () => {
    const start = +DateTime.fromISO(this.props.time).toUTC();
    const now = +DateTime.local().toUTC();
    const nextDelay = 1000 * 60 * 15;

    const disableStatuses = ['finished', 'terminated', 'aborted'];

    if (disableStatuses.includes(this.props.status)) {
      this.setState({
        label: this.props.status,
        time: '',
        ico: null
      });
      return;
    }

    if (this.props.isOnLive) {
      let time = DateTime.fromMillis(now - start);
      this.setState({
        time: Math.floor(+time / 1000 / 60 / 60) + time.toFormat(' : mm : ss'),
        ico: 'on',
        label: 'live'
      });

      this.timeout = setTimeout(this.setLiveStatus, 1000);
      return;
    }

    if (start - now <= nextDelay) {
      const mins = DateTime.fromMillis(start - now).toFormat('m');
      const plurals = this.props.common.strings[
        'page.dashboard.lives.live.time.format'
      ];

      this.setState({
        time: plural(mins, plurals),
        ico: 'off'
      });

      this.timeout = setTimeout(this.setLiveStatus, 1000 * 60);
      return;
    }

    this.setState({
      time: DateTime.fromMillis(start).toFormat(
        this.props.common.strings['page.dashboard.lives.live.date.format']
      ),
      ico: null
    });
  };
}

class GridStatusComponent extends StatusBase {
  static defaultProps = {
    prefix: 'gc'
  };

  render() {
    const { prefix } = this.props;
    return (
      <div className={`${prefix}-time`}>
        <span
          className={`${prefix}-time__ico ${prefix}-time__ico--${this.state.ico}`}
        >
          {this.state.label}
        </span>
        <span className={`${prefix}__time`}>
          {this.props.tbc && !this.props.isOnLive
            ? this.props.common.strings['time_to_be_confirmed']
            : this.state.time}
        </span>
      </div>
    );
  }
}

class ListStatusMobileComponent extends StatusBase {
  render() {
    return (
      <span className={`lc-mtime__ico lc-mtime__ico--${this.state.ico}`}>
        {this.state.label}
      </span>
    );
  }
}

class ListStatusComponent extends StatusBase {
  render() {
    return (
      <div className="lc-time">
        <span className={`lc-time__ico lc-time__ico--${this.state.ico}`}>
          {this.state.label}
        </span>
        <span className="lc__time">
          {this.props.tbc && !this.props.isOnLive
            ? this.props.common.strings['time_to_be_confirmed']
            : this.state.time}
        </span>
      </div>
    );
  }
}

class ViewStatusComponent extends StatusBase {
  render() {
    return (
      <span className="live__status">
        <span
          className={`live__status-ico live__status-ico--${this.state.ico}`}
        >
          {this.state.label}
        </span>
        <span className="live__time">
          {this.props.tbc && !this.props.isOnLive
            ? this.props.common.strings['time_to_be_confirmed']
            : this.state.time}
        </span>
      </span>
    );
  }
}

export const GridStatus = DI(['user'])(GridStatusComponent);

export const ListStatusMobile = DI(['user'])(ListStatusMobileComponent);

export const ListStatus = DI(['user'])(ListStatusComponent);

export const ViewStatus = DI(['user'])(ViewStatusComponent);
